import { Box, Card, CardContent, Chip, Grid, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import IconButton from "@mui/material/IconButton";
import React, { useEffect, useState } from "react";
import {
  Phone as PhoneIcon,
  OpenInNew as OpenInNewIcon,
  Reply as ReplyIcon,
  ContentCopy as ContentCopyIcon,
  LocationOn as LocationIcon,
  List as ListIcon,
  PictureAsPdf as PdfIcon,
  InsertDriveFile as DocumentIcon,
} from "@mui/icons-material";
import PDFPreview from "../Whatsapp/PDFPreview";
import { ColorsConstants } from "../../cssUtils/constants";
import { ReactComponent as Text } from "../../assets/images/icons/campaign/broadcast/chip-text.svg";
import { ReactComponent as Image } from "../../assets/images/icons/campaign/broadcast/chip-image.svg";
import { ReactComponent as Video } from "../../assets/images/icons/campaign/broadcast/chip-video.svg";
import { ReactComponent as Pdf } from "../../assets/images/icons/campaign/broadcast/chip-pdf.svg";

import { ReactComponent as Video2 } from "../../assets/images/icons/campaign/broadcast/chip-video-2.svg";
import { ReactComponent as Carousel } from "../../assets/images/icons/campaign/broadcast/chip-carousel.svg";

// Import the markdown conversion function from MessageNode.js
const convertMarkdownToHtml = (content) => {
  if (!content) return "";

  let html = content;

  // Convert bold (asterisks)
  html = html.replace(/\*(?! )([^\n*]+)(?<! )\*/g, "<strong>$1</strong>");

  // Convert italic (underscores)
  html = html.replace(/_(?! )([^\n_]+)(?<! )_/g, "<em>$1</em>");

  // Convert strikethrough (tildes)
  html = html.replace(/~(?! )([^\n~]+)(?<! )~/g, "<s>$1</s>");

  // Convert monospace (backticks)
  html = html.replace(
    /```([^`]+)```/g,
    '<span style="font-family: monospace; background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px; font-size: 0.9em;">$1</span>',
  );

  // Convert inline code (single backtick)
  html = html.replace(
    /`(?! )([^\n`]+)(?<! )`/g,
    '<span style="font-family: monospace; background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px; font-size: 0.9em;">$1</span>',
  );

  // Convert quotes
  html = html.replace(
    /^\s*>\s*(.+)$/gm,
    '<blockquote style="padding: 8px 12px; border-left: 4px solid #ccc; background-color: #f9f9f9; margin: 8px 0;">$1</blockquote>',
  );

  // Convert bulleted lists
  const bulletListRegex = /^(\* .+)$/gm;
  if (bulletListRegex.test(html)) {
    let bulletMatches = html.match(bulletListRegex);
    if (bulletMatches) {
      let replacementHtml = "<ul>";
      bulletMatches.forEach((item) => {
        replacementHtml += `<li>${item.substring(2).trim()}</li>`;
      });
      replacementHtml += "</ul>";

      const consecutiveBulletItems = bulletMatches
        .map((item) => item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("\\n");

      const blockRegex = new RegExp(consecutiveBulletItems, "g");
      html = html.replace(blockRegex, replacementHtml);
    }
  }

  // Convert hyphen lists
  const hyphenListRegex = /^(- .+)$/gm;
  if (hyphenListRegex.test(html)) {
    let hyphenMatches = html.match(hyphenListRegex);
    if (hyphenMatches) {
      let replacementHtml = "<ul>";
      hyphenMatches.forEach((item) => {
        replacementHtml += `<li>${item.substring(2).trim()}</li>`;
      });
      replacementHtml += "</ul>";

      const consecutiveHyphenItems = hyphenMatches
        .map((item) => item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("\\n");

      const blockRegex = new RegExp(consecutiveHyphenItems, "g");
      html = html.replace(blockRegex, replacementHtml);
    }
  }

  // Convert numbered lists
  const numberedListRegex = /^(\d+\. .+)$/gm;
  if (numberedListRegex.test(html)) {
    let numberedMatches = html.match(numberedListRegex);
    if (numberedMatches) {
      let replacementHtml = "<ol>";
      numberedMatches.forEach((item) => {
        const content = item.substring(item.indexOf(".") + 2).trim();
        replacementHtml += `<li>${content}</li>`;
      });
      replacementHtml += "</ol>";

      const consecutiveNumberedItems = numberedMatches
        .map((item) => item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("\\n");

      const blockRegex = new RegExp(consecutiveNumberedItems, "g");
      html = html.replace(blockRegex, replacementHtml);
    }
  }

  // Normalize Windows line endings
  html = html.replace(/\r\n/g, "\n");

  // Split into lines
  const lines = html.split("\n");

  // Convert lines to HTML with correct spacing
  html = lines
    .map((line) => {
      if (line === "") {
        return "<br>";
      }
      return `${line}<br>`;
    })
    .join("");

  return html;
};
const TemplateGridCard = React.forwardRef(
  (
    {
      id,
      name,
      category,
      hasMedia,
      message,
      footer,
      language,
      date,
      status,
      mediaFile,
      onClick,
      selected,
      template_json,
      template_preview_json,
      showSampleValues = false,
      sampleBodyFields = [],
      sampleHeaderFields = [],
    },
    ref,
  ) => {
    function getMediaType(url) {
      if (!url) return null;
      // Handle File objects
      if (url instanceof File) {
        if (url.type.startsWith("video/")) return "video";
        if (url.type.startsWith("image/")) return "image";
        if (url.type === "application/pdf") return "document";
        if (url.type.includes("document") || url.type.includes("pdf"))
          return "document";
        return null;
      }

      // Handle string URLs
      if (typeof url === "string") {
        const ext = url.split(".").pop().toLowerCase();
        if (["mp4", "mov", "webm", "avi"].includes(ext)) return "video";
        if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext))
          return "image";
        if (["pdf", "doc", "docx", "txt", "ppt", "pptx"].includes(ext))
          return "document";
        if (url.includes("blob:")) return "image"; // Assume blob URLs are images
      }

      return null;
    }

    const [type, setType] = useState(null);
    const [parsedLocation, setParsedLocation] = useState(null);
    const [documentFileName, setDocumentFileName] = useState("");
    const [mediaUrl, setMediaUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [cardMediaUrls, setCardMediaUrls] = useState({});
    const [isCarouselLoading, setIsCarouselLoading] = useState(false);
    useEffect(() => {
      const mediaType = getMediaType(mediaFile);
      setType(mediaType);

      // Parse location data from template_preview_json
      if (template_preview_json?.location) {
        try {
          const locationData =
            typeof template_preview_json.location === "string"
              ? JSON.parse(template_preview_json.location)
              : template_preview_json.location;
          setParsedLocation(locationData);
        } catch (error) {
          console.error("Error parsing location data:", error);
          setParsedLocation(null);
        }
      } else {
        setParsedLocation(null);
      }

      // Extract document filename from URL
      if (mediaFile && typeof mediaFile === "string") {
        const filename = mediaFile.split("/").pop();
        setDocumentFileName(filename || "document.pdf");
      } else if (mediaFile instanceof File) {
        setDocumentFileName(mediaFile.name || "document.pdf");
      } else {
        setDocumentFileName("");
      }
    }, [mediaFile, template_preview_json]);

    // Fetch PDF separately when headerType is document
    useEffect(() => {
      const fetchPDF = async () => {
        if (
          template_preview_json?.headerType === "document" &&
          template_preview_json?.headerFile
        ) {
          setIsLoading(true);
          try {
            const pdfFile = template_preview_json.headerFile;

            if (typeof pdfFile === "string") {
              // If it's a URL, check if it's a localhost URL that needs headers
              if (pdfFile.includes("localhost:8000")) {
                const tenant = localStorage.getItem("tenant");
                // Use proper header format without dashes in the middle
                const headers = {
                  "X-Tenant-ID": tenant || "", // Use proper header name
                };

                const response = await fetch(pdfFile, {
                  headers: new Headers(headers),
                });

                if (!response.ok) throw new Error("Failed to fetch PDF");

                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                setMediaUrl(objectUrl);
              } else {
                // For external URLs, use directly
                setMediaUrl(pdfFile);
              }
            } else if (pdfFile instanceof File) {
              // If it's a File object, create blob URL
              const objectUrl = URL.createObjectURL(pdfFile);
              setMediaUrl(objectUrl);
            } else {
              setMediaUrl(pdfFile);
            }
          } catch (error) {
            console.error("Error fetching PDF:", error);
            // Fallback to direct URL
            setMediaUrl(template_preview_json.headerFile);
          } finally {
            setIsLoading(false);
          }
        }
      };

      fetchPDF();
    }, [template_preview_json]);

    // Cleanup function for blob URLs
    useEffect(() => {
      return () => {
        if (mediaUrl && mediaUrl.startsWith("blob:")) {
          URL.revokeObjectURL(mediaUrl);
        }
      };
    }, [mediaUrl]);

    // Extract data from template_json and template_preview_json
    const previewJson = template_preview_json || {};
    const templateJson = template_json || {};

    // Get header type and text from preview JSON
    const headerType = previewJson.headerType || "text";
    const headerText = previewJson.headerText || "";
    const headerFile = previewJson.headerFile || mediaFile;

    // Get buttons from preview JSON - handle both string and array formats
    const getButtons = () => {
      if (previewJson.allButtons && Array.isArray(previewJson.allButtons)) {
        return previewJson.allButtons;
      }

      // Try to parse buttons from template_json if they're stored as string
      if (templateJson.buttons && typeof templateJson.buttons === "string") {
        try {
          return JSON.parse(templateJson.buttons);
        } catch (error) {
          console.error("Error parsing buttons from template_json:", error);
        }
      }

      return [];
    };

    const buttons = getButtons();

    // Get marketing option and carousel data

    const marketingOption = previewJson.marketingOption || "custom";
    const isCarouselTemplate = marketingOption === "carousel";
    const carouselCards = previewJson.carouselCards || [];
    const carouselType = previewJson.carouselType || "image";
    const carouselMainBody = previewJson.carouselMainBody || "";

    // Function to replace placeholders with sample data
    const replacePlaceholders = (text, sampleFields) => {
      if (!text || !sampleFields || !Array.isArray(sampleFields)) return text;

      let replacedText = text;

      // Escape special regex characters in case they exist in the text
      for (let i = 0; i < sampleFields.length; i++) {
        // The pattern needs to match exactly {{1}}, {{2}}, etc.
        const pattern = "{{" + (i + 1) + "}}";

        // Simple string replacement
        replacedText = replacedText.replaceAll(
          pattern,
          `{{${sampleFields[i].value || i + 1}}}` || "",
        );
      }

      return replacedText;
    };

    // Get current carousel card data
    const getCurrentCarouselCard = () => {
      if (!carouselCards) return null;

      let parsedCards = carouselCards;
      if (typeof carouselCards === "string") {
        try {
          parsedCards = JSON.parse(carouselCards);
        } catch (error) {
          parsedCards = [];
        }
      }

      if (
        Array.isArray(parsedCards) &&
        parsedCards.length > 0 &&
        currentCardIndex < parsedCards.length
      ) {
        return parsedCards[currentCardIndex];
      }
      return null;
    };
    // In the useEffect for loading carousel media, add video-specific handling:
    useEffect(() => {
      if (marketingOption === "carousel" && carouselCards) {
        // Parse carousel cards if they're stored as a string
        let parsedCards = carouselCards;
        if (typeof carouselCards === "string") {
          try {
            parsedCards = JSON.parse(carouselCards);
          } catch (error) {
            console.error("Error parsing carousel cards:", error);
            parsedCards = [];
          }
        }

        // Load media for the current card
        if (
          Array.isArray(parsedCards) &&
          parsedCards.length > 0 &&
          currentCardIndex < parsedCards.length
        ) {
          loadCardMedia(parsedCards[currentCardIndex], currentCardIndex);
        }
      }
    }, [marketingOption, carouselCards, currentCardIndex]);

    // Update loadCardMedia function to handle video files better:
    const loadCardMedia = async (card, index) => {
      if (!card) return;

      const cardFileKey = `cardFile_${index}`;
      const cardFile = previewJson[cardFileKey];

      if (cardFile) {
        setIsCarouselLoading(true);
        try {
          // Handle different types of files
          if (typeof cardFile === "string") {
            // For localhost URLs, we might need to add headers
            if (cardFile.includes("localhost:8000")) {
              const tenant = localStorage.getItem("tenant");
              const headers = {
                "X-Tenant-ID": tenant || "",
              };

              const response = await fetch(cardFile, {
                headers: new Headers(headers),
              });

              if (response.ok) {
                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                setCardMediaUrls((prev) => ({ ...prev, [index]: objectUrl }));
              } else {
                setCardMediaUrls((prev) => ({ ...prev, [index]: cardFile }));
              }
            } else {
              // For external URLs, use directly
              setCardMediaUrls((prev) => ({ ...prev, [index]: cardFile }));
            }
          } else if (cardFile instanceof File) {
            // For File objects
            const objectUrl = URL.createObjectURL(cardFile);
            setCardMediaUrls((prev) => ({ ...prev, [index]: objectUrl }));
          } else {
            setCardMediaUrls((prev) => ({ ...prev, [index]: cardFile }));
          }
        } catch (error) {
          console.error(
            `Error loading carousel media for card ${index}:`,
            error,
          );
          setCardMediaUrls((prev) => ({ ...prev, [index]: cardFile }));
        } finally {
          setIsCarouselLoading(false);
        }
      }
    };

    // Carousel navigation
    const handleCarouselNavigation = (direction) => {
      if (!carouselCards) return;

      let parsedCards = carouselCards;
      if (typeof carouselCards === "string") {
        try {
          parsedCards = JSON.parse(carouselCards);
        } catch (error) {
          parsedCards = [];
        }
      }

      if (direction === "next" && currentCardIndex < parsedCards.length - 1) {
        setCurrentCardIndex((prev) => prev + 1);
      } else if (direction === "prev" && currentCardIndex > 0) {
        setCurrentCardIndex((prev) => prev - 1);
      }
    };
    // Apply sample replacements if showSampleValues is true
    const displayHeaderText = replacePlaceholders(
      headerText,
      sampleHeaderFields,
    );

    const displayMessage = replacePlaceholders(message, sampleBodyFields);

    // Convert markdown to HTML for display
    const displayMessageHtml = convertMarkdownToHtml(displayMessage);
    const displayFooterHtml = convertMarkdownToHtml(footer || "");

    // Get button icon based on type
    function getButtonIcon(buttonType) {
      switch (buttonType) {
        case "call-phone-number":
        case "PHONE_NUMBER":
          return (
            <PhoneIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
        case "visit-website":
        case "URL":
          return (
            <OpenInNewIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
        case "marketing-opt-out":
        case "QUICK_REPLY":
          return (
            <ReplyIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
        case "custom":
          return (
            <ReplyIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
        case "copy-code":
          return (
            <ContentCopyIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
        case "autofill":
          return (
            <OpenInNewIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
        default:
          return (
            <ReplyIcon
              sx={{ fontSize: 12, color: ColorsConstants.primaryBlue100 }}
            />
          );
      }
    }

    // Render button preview
    function renderButton(buttonData, index) {
      // Handle different button data structures
      const buttonText =
        buttonData.data?.buttonText || buttonData.text || "Button";
      const buttonType = buttonData.type || "custom";

      return (
        <Box
          key={index}
          sx={{
            width: "100%",
            height: "30px",
            minHeight: "30px",
            backgroundColor: "#FFFFFF",
            padding: "5.34103px 0px",
            marginBottom: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            borderRadius: "4px",
            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            "&:hover": {
              backgroundColor: "#f8f9fa",
            },
          }}
        >
          {getButtonIcon(buttonType)}
          <Typography
            align="center"
            color={ColorsConstants.primaryBlue100}
            fontSize="14px"
            fontWeight={400}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {buttonText}
          </Typography>
        </Box>
      );
    }

    // Render location preview
    function renderLocation() {
      if (!parsedLocation) return null;

      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          {/* Location Map Area */}
          <Box
            sx={{
              width: "100%",
              height: "110px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgb(230, 230, 230)",
              borderRadius: "8px",
              marginBottom: "8px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Large Location Icon */}
            <LocationIcon
              sx={{
                fontSize: "48px",
                color: "#f44336",
                zIndex: 2,
              }}
            />

            {/* Coordinates */}
            <Typography
              sx={{
                fontSize: "12px",
                textAlign: "center",
                mt: 1,
                zIndex: 2,
                color: "rgba(0,0,0,0.8)",
              }}
            >
              ({parsedLocation.latitude}°, {parsedLocation.longitude}°)
            </Typography>

            {/* Subtle grid pattern background */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `
                linear-gradient(rgba(0,0,0,0.05) 1px, transparent 1px),
                linear-gradient(90deg, rgba(0,0,0,0.05) 1px, transparent 1px)
              `,
                backgroundSize: "20px 20px",
                opacity: 0.3,
                zIndex: 1,
              }}
            />
          </Box>

          {/* Location Details */}
          <Box sx={{ width: "100%", padding: "0 4px" }}>
            {/* Location Name */}
            {parsedLocation.name && (
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "text.primary",
                  mb: 0.5,
                }}
              >
                {parsedLocation.name}
              </Typography>
            )}

            {/* Location Address */}
            {parsedLocation.address && (
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "text.secondary",
                  lineHeight: 1.3,
                }}
              >
                {parsedLocation.address}
              </Typography>
            )}
          </Box>
        </Box>
      );
    }

    // Render image/video header
    function renderMediaHeader() {
      if (
        !headerFile ||
        (headerType !== "image" && headerType !== "video" && headerType !== "gif")
      ) {
        return null;
      }

      const mediaType = getMediaType(headerFile);

      if (mediaType === "image") {
        return (
          <Box
            component="img"
            src={mediaFile}
            alt="media"
            sx={{
              width: "100%",
              height: 140, // Reduced height to fit better
              objectFit: "cover",
              borderRadius: 1,
            }}
          />
        );
      }

      if (mediaType === "video") {
        return (
          <Box
            component="video"
            src={mediaFile}
            controls
            sx={{
              width: "100%",
              height: 140, // Reduced height to fit better
              borderRadius: 1,
              objectFit: "cover",
            }}
          />
        );
      }

      return null;
    }

    // Render PDF preview using PDFPreview component - SIMPLIFIED VERSION
    function renderPDFPreview() {
      if (!headerFile || headerType !== "document") {
        return null;
      }

      // For PDFPreview, pass either the mediaUrl or the file object
      const pdfSource = mediaUrl || headerFile;

      return (
        <Box
          sx={{
            width: "100%",
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "140px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {isLoading ? (
            <Box
              sx={{
                width: "100%",
                height: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                Loading PDF...
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                padding: "0px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <PDFPreview pdfFile={pdfSource} />
              </Box>
            </Box>
          )}
        </Box>
      );
    }

    // Render carousel preview
    // In the TemplateGridCard component, update the renderCarouselPreview function:

    function renderCarouselPreview() {
      const currentCard = getCurrentCarouselCard();
      const parsedCards =
        typeof carouselCards === "string"
          ? JSON.parse(carouselCards)
          : carouselCards;

      if (!currentCard || !Array.isArray(parsedCards)) {
        return (
          <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
            No carousel cards available
          </Typography>
        );
      }

      // Get card media file
      const cardFileKey = `cardFile_${currentCardIndex}`;
      const cardFile = previewJson[cardFileKey];
      const mediaUrl = cardMediaUrls[currentCardIndex] || cardFile;

      // Determine if current card is video
      const isVideoCard = (() => {
        // Check carouselType from props
        if (carouselType === "video") return true;

        // Check current card's headerType
        if (
          currentCard.headerType &&
          currentCard.headerType.toLowerCase() === "video"
        )
          return true;

        // Check file extension if mediaUrl is a string
        if (mediaUrl && typeof mediaUrl === "string") {
          const ext = mediaUrl.split(".").pop().toLowerCase();
          return ["mp4", "mov", "webm", "avi", "mpeg"].includes(ext);
        }

        // Check File object type
        if (cardFile instanceof File && cardFile.type.startsWith("video/"))
          return true;

        return false;
      })();

      return (
        <Box sx={{ position: "relative", width: "100%" }}>
          {/* Carousel Main Body */}
          {carouselMainBody && (
            <Typography
              sx={{
                fontSize: "14px",
                color: "text.primary",
                mb: 1,
                wordBreak: "break-word",
              }}
            >
              {carouselMainBody}
            </Typography>
          )}

          {/* Carousel Card */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "#ffffff",
              position: "relative",
            }}
          >
            {/* Navigation Arrows */}
            {parsedCards.length > 1 && (
              <>
                {currentCardIndex > 0 && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCarouselNavigation("prev");
                    }}
                    size="small"
                    sx={{
                      position: "absolute",
                      left: 4,
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255,255,255,0.7)",
                      zIndex: 2,
                      width: 20,
                      height: 20,
                      minWidth: 20,
                      minHeight: 20,
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.9)",
                      },
                    }}
                  >
                    <ArrowBackIosNewIcon sx={{ fontSize: "12px" }} />
                  </IconButton>
                )}

                {currentCardIndex < parsedCards.length - 1 && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCarouselNavigation("next");
                    }}
                    size="small"
                    sx={{
                      position: "absolute",
                      right: 4,
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255,255,255,0.7)",
                      zIndex: 2,
                      width: 20,
                      height: 20,
                      minWidth: 20,
                      minHeight: 20,
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.9)",
                      },
                    }}
                  >
                    <ArrowForwardIosIcon sx={{ fontSize: "12px" }} />
                  </IconButton>
                )}
              </>
            )}

            {/* Card Media - Video or Image */}
            {mediaUrl && (
              <Box
                sx={{
                  width: "100%",
                  height: isVideoCard ? "120px" : "80px", // More height for video to show controls
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f5f5f5",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {isCarouselLoading ? (
                  <Typography
                    sx={{ fontSize: "10px", color: "text.secondary" }}
                  >
                    Loading...
                  </Typography>
                ) : isVideoCard ? (
                  // Video player with native controls
                  <Box
                    component="video"
                    src={mediaUrl}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    muted
                    playsInline
                    controls // This enables the native video controls
                    preload="metadata"
                    onError={(e) => {
                      console.error("Error loading video:", mediaUrl);
                      e.target.style.display = "none";
                      // Show fallback image
                      const fallback = document.createElement("div");
                      fallback.innerHTML = `
                      <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#e0e0e0;">
                        <span style="color:#999;font-size:10px;">Video not available</span>
                      </div>
                    `;
                      e.target.parentNode.appendChild(fallback.firstChild);
                    }}
                    onClick={(e) => {
                      // Prevent card click when clicking video controls
                      e.stopPropagation();
                    }}
                  />
                ) : (
                  // Image
                  <Box
                    component="img"
                    src={mediaUrl}
                    alt={`Card ${currentCardIndex + 1}`}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjgwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iODAiIGZpbGw9IiNlZWVlZWUiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5JbWFnZTwvdGV4dD48L3N2Zz4=";
                    }}
                  />
                )}
              </Box>
            )}

            {/* Card Body */}
            <Box sx={{ p: 1 }}>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "text.primary",
                  wordBreak: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {currentCard.body || "Carousel Card"}
              </Typography>
            </Box>
          </Box>

          {/* Pagination Indicators */}
          {parsedCards.length > 1 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "4px",
                mt: 1,
              }}
            >
              {parsedCards.map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor:
                      index === currentCardIndex ? "#1976d2" : "#e0e0e0",
                  }}
                />
              ))}
            </Box>
          )}
        </Box>
      );
    }
    // Determine template types
    const isLocationTemplate =
      headerType === "location" || parsedLocation !== null;
    const isMediaTemplate =
      headerType === "image" || headerType === "video" || headerType === "gif";
    const isDocumentTemplate = headerType === "document";
    const isTextTemplate = template_json.templateType.toLowerCase() === "text";
    const isImageCarousel = template_preview_json?.carouselType === "image";
    const isVideoCarousel = template_preview_json?.carouselType === "video";
    return (
      
       <Card
    ref={ref}
    onClick={onClick}
    sx={{
      border: selected
        ? `2px solid ${ColorsConstants.primaryBlue100}`
        : "1px solid #e0e0e0",
      width: "100%", // Change from fixed 282px to 100%
      
      height: 296,
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
      boxShadow: selected ? 3 : 1,
      "&:hover": {
        boxShadow: 4,
      },
      transition: "all 0.2s",
      overflow: "hidden",
      backgroundColor: "#f5f5f5",
      borderRadius: "12px",
      margin: "0 auto", // Center the card
    }}
  >
          {/* Header */}
          <Box
            sx={{
              p: 1.5,
              borderBottom: 1,
              borderColor: "divider",
              flexShrink: 0,
              backgroundColor: selected ? "#f0f7ff" : "#ffffff",
            }}
          >
            <Typography
              variant="body2"
              fontWeight="700"
              sx={{
                mb: 0.5,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "0.9rem",
              }}
            >
              {name}
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {status && (
                <Chip
                  label={status}
                  size="small"
                  sx={{
                    height: 18,
                    fontWeight: 500,
                    fontSize: "0.7rem",
                    borderRadius: "4px",
                    backgroundColor:
                      status === "APPROVED"
                        ? "#E8F5E9" // Light green
                        : status === "PENDING"
                          ? "#FFF3E0" // Light orange
                          : status === "REJECTED"
                            ? "#FFEBEE" // Light red
                            : "#F5F5F5", // Light grey for default
                    color:
                      status === "APPROVED"
                        ? "#2E7D32" // Dark green
                        : status === "PENDING"
                          ? "#ED6C02" // Dark orange
                          : status === "REJECTED"
                            ? "#D32F2F" // Dark red
                            : "#616161", // Dark grey for default

                    "& .MuiChip-label": {
                      px: 1,
                    },
                  }}
                />
              )}

              {isCarouselTemplate && (
                <Chip
                  icon={<Carousel style={{ fontSize: "12px", width: 14 }} />}
                  label="Carousel"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    borderRadius: "4px",
                    fontSize: "0.7rem",
                    px: "8px",
                    color: "#7B3FE4",
                    backgroundColor: "#F3E8FF",
                    border: "none",
                  }}
                />
              )}

              {isCarouselTemplate && isImageCarousel && (
                <Chip
                  label="Image"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    borderRadius: "4px",
                    fontSize: "0.7rem",
                    px: "8px",
                    color: "#0F766E",
                    backgroundColor: "#E6FFFA",
                    border: "none",
                  }}
                />
              )}
              {isCarouselTemplate && isVideoCarousel && (
                <Chip
                  icon={<Video2 style={{ fontSize: "12px", width: 14 }} />}
                  label="Video"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    borderRadius: "4px",
                    fontSize: "0.7rem",
                    px: "8px",

                    color: "#326861", // Text = border color
                    backgroundColor: "#E6F4F3", // Light teal background
                    border: "none",
                  }}
                />
              )}
              {isTextTemplate && (
                <Chip
                  icon={<Text style={{ fontSize: "12px" }} />}
                  label="Text"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    px: "8px",
                    fontSize: "0.7rem",
                    borderRadius: "4px",
                    color: "#367EE2",
                    backgroundColor: "#E9F1FB",
                    border: "none",
                  }}
                />
              )}

              {isLocationTemplate && (
                <Chip
                  icon={<LocationIcon sx={{ fontSize: "12px" }} />}
                  label="Location"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    fontSize: "0.7rem",
                    borderRadius: "4px",
                    color: "#d32f2f",
                    px: "8px",

                    borderColor: "#d32f2f",
                    border: "none",
                  }}
                />
              )}
              {isMediaTemplate && headerType === "video" && (
                <Chip
                  icon={<Video style={{ fontSize: "12px", width:14 }} />}
                  label="Video"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    borderRadius: "4px",
                    fontSize: "0.7rem",
                    px: "8px",
                    color: "#BE123C",
                    backgroundColor: "#FFE4E6",
                    border: "none",
                  }}
                />
              )}
              {isMediaTemplate && headerType === "image" && (
                <Chip
                  icon={<Image style={{ fontSize: "12px", width: 14 }} />}
                  label="Image"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    fontSize: "0.7rem",
                    borderRadius: "4px",
                    px: "8px",

                    color: "#F47B25",
                    backgroundColor: "#FDF0E7",
                    border: "none",
                  }}
                />
              )}
              {isMediaTemplate && headerType === "gif" && (
                <Chip
                  icon={<Image style={{ fontSize: "12px", width: 14 }} />}
                  label="GIF"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    fontSize: "0.7rem",
                    borderRadius: "4px",
                    px: "8px",
                    color: "#F47B25",
                    backgroundColor: "#FDF0E7",
                    border: "none",
                  }}
                />
              )}
              {isDocumentTemplate && (
                <Chip
                  icon={<Pdf style={{ fontSize: "8px", width: 14 }} />}
                  label="PDF"
                  size="small"
                  variant="outlined"
                  sx={{
                    height: 18,
                    fontSize: "0.7rem",
                    borderRadius: "4px",
                    px: "8px",
                    color: "#f44336",
                    backgroundColor: "#FDECEA",
                    border: "none",
                  }}
                />
              )}
            </Box>
          </Box>

          {/* Content Preview */}
          <CardContent
            sx={{
              flexGrow: 1,
              width: "100%",
              height: "auto",
              overflow: "auto",
              p: 1.5,
              backgroundColor: "#f5f5f5",
              "&::-webkit-scrollbar": { width: "4px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.2)",
                borderRadius: "2px",
              },
            }}
          >
            {/* Main Content Card */}
            <Box
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                padding: "12px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                mb: 2,
              }}
            >
              {/* Carousel Template */}
              {isCarouselTemplate && renderCarouselPreview()}

              {/* PDF Preview using PDFPreview component */}
              {!isCarouselTemplate && isDocumentTemplate && renderPDFPreview()}

              {/* Media Header (Image/Video) */}
              {!isCarouselTemplate && isMediaTemplate && renderMediaHeader()}

              {/* Location Preview */}
              {!isCarouselTemplate && isLocationTemplate && renderLocation()}

              {/* Text Header (if it's a text header type) */}
              {!isCarouselTemplate && headerType === "text" && headerText && (
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "text.primary",
                    mb: 2,
                    wordBreak: "break-word",
                  }}
                >
                  {displayHeaderText}
                </Typography>
              )}

              {/* Message Body - only show for non-carousel templates */}
              {!isCarouselTemplate && message && (
                <Typography
                  sx={{
                    display: "block",
                    whiteSpace: "pre-wrap",
                    color: "text.primary",
                    lineHeight: 1.5,
                    wordBreak: "break-word",
                    fontSize: "14px",
                    mb: footer ? 1 : 0,
                    mt:
                      isLocationTemplate ||
                      isMediaTemplate ||
                      isDocumentTemplate
                        ? 0
                        : 0,
                  }}
                  dangerouslySetInnerHTML={{ __html: displayMessageHtml }}
                />
              )}

              {/* Footer */}
              {!isCarouselTemplate && footer && (
                <Typography
                  sx={{
                    display: "block",
                    mt: 1,
                    fontStyle: "italic",
                    color: "text.secondary",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    paddingTop: "8px",
                    borderTop: footer ? "1px solid #f0f0f0" : "none",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayFooterHtml }}
                />
              )}
            </Box>

            {/* Buttons Section */}
            {isCarouselTemplate
              ? // For carousel, show first card's first button if available
                (() => {
                  const currentCard = getCurrentCarouselCard();
                  if (currentCard?.buttons && currentCard.buttons.length > 0) {
                    // Take only first button from the current card
                    const firstButton = currentCard.buttons[0];
                    return (
                      <Box sx={{ mt: 1 }}>
                        {renderButton(firstButton, 0)}
                        {currentCard.buttons.length > 1 && (
                          <Box
                            sx={{
                              width: "100%",
                              height: "30px",
                              backgroundColor: "#FFFFFF",
                              padding: "5.34103px 0px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                              borderRadius: "4px",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                              mt: 0.5,
                              "&:hover": {
                                backgroundColor: "#f8f9fa",
                              },
                            }}
                          >
                            <ListIcon
                              sx={{
                                fontSize: 16,
                                color: ColorsConstants.primaryBlue100,
                              }}
                            />
                            <Typography
                              align="center"
                              color={ColorsConstants.primaryBlue100}
                              fontSize="14px"
                              fontWeight={400}
                            >
                              See all options
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    );
                  }
                  return null;
                })()
              : // Regular buttons for non-carousel templates
                buttons &&
                buttons.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    {/* Show first 2 buttons in grid card view */}
                    {buttons
                      .slice(0, 2)
                      .map((button, index) => renderButton(button, index))}

                    {/* Show "See all options" if there are more than 2 buttons */}
                    {buttons.length > 2 && (
                      <Box
                        sx={{
                          width: "100%",
                          height: "30px",
                          backgroundColor: "#FFFFFF",
                          padding: "5.34103px 0px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          borderRadius: "4px",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          mt: 0.5,
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                          },
                        }}
                      >
                        <ListIcon
                          sx={{
                            fontSize: 16,
                            color: ColorsConstants.primaryBlue100,
                          }}
                        />
                        <Typography
                          align="center"
                          color={ColorsConstants.primaryBlue100}
                          fontSize="14px"
                          fontWeight={400}
                        >
                          See all options
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}
          </CardContent>

          {/* Footer with language and date */}
          <Box
            sx={{
              px: 1.5,
              py: 1,
              borderTop: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0,
              backgroundColor: "#ffffff",
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.7rem" }}
            >
              {language || templateJson.languageCode || "English"}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.7rem" }}
            >
              {date}
            </Typography>
          </Box>
        </Card>
     
    );
  },
);

export default React.memo(TemplateGridCard);
